
import { FunnelsServices } from "@/services";
import Vue from "vue";
import moment from 'moment'
export default Vue.extend({
  data() {
    return {
      domain: "",
      connectedDetails: [],
      loadingDetails: false,
    };
  },
  methods: {
    async fetchDomainDetails() {
      try {
        this.loadingDetails = true;
        const { data } = await FunnelsServices.fetchDomainLogs({
          domain: this.domain,
        });
        this.connectedDetails = data;
        this.loadingDetails = false;
      } catch (error) {
        console.error(error);
      }
    },
    formatDate(date:string){
      if(!date) return ''
      return moment(date).format('MMMM Do YYYY, h:mm:ss a')
    }
  },
});
